import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthState } from '../services/auth.state';
import { resolveAuthRedirect } from '../utils/auth-redirect.util';

/**
 * Bloquea `/auth` si ya hay sesión. Si viene `?redirect=` interno, navega ahí;
 * si no, a mis cursos.
 */
export const guestGuard: CanActivateFn = (route, state) => {
  const authState = inject(AuthState);
  const router = inject(Router);
  if (!authState.isLoggedIn()) return true;

  const fromChild = route.queryParamMap.get('redirect');
  const fromUrl = router.parseUrl(state.url).queryParams['redirect'];
  const raw = fromChild ?? (typeof fromUrl === 'string' ? fromUrl : null);
  return router.parseUrl(resolveAuthRedirect(raw));
};
